import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Popover, PopoverTrigger, PopoverContent } from "./ui/popover";
import { Calendar } from "./ui/calendar";
import { Button } from "./ui/button";
import { CalendarDays, Users, Search } from "lucide-react";
import { format } from "date-fns";
import { ptBR } from "date-fns/locale";

function toISO(d) {
  if (!d) return "";
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

export default function HeroSearch({ compact = false }) {
  const [range, setRange] = useState({ from: undefined, to: undefined });
  const [guests, setGuests] = useState(2);
  const nav = useNavigate();

  function submit() {
    const params = new URLSearchParams();
    if (range?.from) params.set("check_in", toISO(range.from));
    if (range?.to) params.set("check_out", toISO(range.to));
    params.set("guests", String(guests));
    nav(`/casas?${params.toString()}`);
  }

  const label = range?.from
    ? range?.to
      ? `${format(range.from, "d MMM", { locale: ptBR })} — ${format(range.to, "d MMM", { locale: ptBR })}`
      : `${format(range.from, "d MMM", { locale: ptBR })}`
    : "Selecione as datas";

  return (
    <div
      data-testid="hero-search"
      className={`bg-white border border-slate-200 rounded-lg ${
        compact ? "shadow-sm" : "shadow-[0_20px_40px_-15px_rgba(26,54,93,0.18)]"
      }`}
    >
      <div className="grid grid-cols-1 md:grid-cols-[1.4fr_1fr_auto] items-stretch divide-y md:divide-y-0 md:divide-x divide-slate-200">
        <Popover>
          <PopoverTrigger asChild>
            <button
              data-testid="date-picker-trigger"
              className="text-left px-5 py-4 flex items-center gap-3 hover:bg-slate-50 transition-colors"
              type="button"
            >
              <CalendarDays className="w-4 h-4 text-[#0AA89C]" />
              <div className="flex flex-col">
                <span className="text-[10px] uppercase tracking-[0.24em] text-slate-500">Datas</span>
                <span className="text-sm font-medium">{label}</span>
              </div>
            </button>
          </PopoverTrigger>
          <PopoverContent className="w-auto p-0 bg-white" align="start">
            <Calendar
              mode="range"
              locale={ptBR}
              selected={range}
              onSelect={setRange}
              numberOfMonths={2}
              disabled={{ before: new Date() }}
            />
          </PopoverContent>
        </Popover>

        <div className="px-5 py-4 flex items-center gap-3">
          <Users className="w-4 h-4 text-[#0AA89C]" />
          <div className="flex flex-col flex-1">
            <span className="text-[10px] uppercase tracking-[0.24em] text-slate-500">Hóspedes</span>
            <div className="flex items-center gap-3 mt-0.5">
              <button
                data-testid="guests-decrease"
                type="button"
                className="w-6 h-6 rounded-full border border-slate-300 text-slate-600 flex items-center justify-center hover:bg-slate-100"
                onClick={() => setGuests(Math.max(1, guests - 1))}
              >
                −
              </button>
              <span data-testid="guests-count" className="text-sm font-medium w-6 text-center">{guests}</span>
              <button
                data-testid="guests-increase"
                type="button"
                className="w-6 h-6 rounded-full border border-slate-300 text-slate-600 flex items-center justify-center hover:bg-slate-100"
                onClick={() => setGuests(guests + 1)}
              >
                +
              </button>
            </div>
          </div>
        </div>

        <div className="p-3 flex items-stretch">
          <Button
            data-testid="hero-search-btn"
            onClick={submit}
            className="w-full md:w-auto bg-[#0AA89C] hover:bg-[#066B63] text-white px-6 rounded-md h-full"
          >
            <Search className="w-4 h-4 mr-2" />
            Buscar
          </Button>
        </div>
      </div>
    </div>
  );
}
